import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HumanizeRecurrenceEditingModePipe } from './humanize-recurrence-editing-mode.pipe'

@NgModule({
  declarations: [HumanizeRecurrenceEditingModePipe],
  imports: [CommonModule],
  exports: [HumanizeRecurrenceEditingModePipe],
  providers: [HumanizeRecurrenceEditingModePipe],
})
export class RecurrencePipesModule {}
